import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Divider } from 'antd';
import Button from '@mui/material/Button';
import './Banner.css'; // Add styles here or use styled-components

const { Title, Paragraph } = Typography;

const Banner = ({
  imgUrl,
  title,
  description,
  color = '#fff',
  topLeftText = 'Back',
  topLeftAction = null,
}) => {
  return (
    <div
      className="banner py-6"
      style={{
        backgroundImage: `url(${imgUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Top-Left Back Button */}
      {topLeftText && (
        <Button
          className="banner-top-left cursor-pointer cursor hover:bg-black/10"
          style={{
            position: 'absolute',
            top: '16px',
            left: '16px',
            background: 'rgba(0, 0, 0, 0.6)',
            padding: '4px 8px 6px 8px',
            borderRadius: '8px',
            cursor: 'pointer',
            color: '#fff',
              textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
          }}
          onClick={topLeftAction}
        >
          {topLeftText}
        </Button>
      )}

      <div className="banner-content w-3/5 mx-auto">
        <Title level={2} className="banner-title" style={{ color }}>
          {title}
        </Title>
        <div className="banner-description-overlay mt-3">
          <Paragraph
            className="banner-description"
            style={{ color }}
            ellipsis={{ rows: 3 }}
          >
            {description}
          </Paragraph>
        </div>
      </div>
    </div>
  );
};

Banner.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  color: PropTypes.string,
  topLeftText: PropTypes.string,
  topLeftAction: PropTypes.func,
};

export default Banner;
